<template>
  <div>
    <v-card class="top-row py-2 px-3 mb-4" elevation="2">
      <div style="250px">
        <v-text-field
          class="search-field mr-2"
          label="Sök efter faktaruta"
          prepend-inner-icon="mdi-magnify"
          clearable
          outlined
          dense
          hide-details="true"
          v-model="search"
        ></v-text-field>
      </div>
    </v-card>
    <div class="fact-list" :class="{loading:loading}">
      <ArtFact v-for="fact in allFacts" :key="fact.id" :fact="fact" @change="onChange" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ArtFact from '@/components/livet/ArtFact'
export default {
  name: 'InfoFacts',
  props: {
    facts: { type: Array },
    loading: { type: Boolean },
  },
  components: {
    ArtFact,
  },
  data() {
    return {
      search: ''
    }
  },
  computed: {
    ...mapGetters('arterFacts', { allArterFacts: 'getArray' }),
    allFacts() {
      const facts = this.allArterFacts.map((fact) => {
        return {
          ...fact,
          selected: this.facts.find((f) => f.fact_id === fact.id) ? true : false,
        }
      }).sort((a, b) => a.title_sve.localeCompare(b.title_sve))
      return this.search ? facts.filter((fact) => fact.title_sve.toLowerCase().includes(this.search.toLowerCase())) : facts
    },
  },
  methods: {
    onChange(fact) {
      const selectedFactsIds = this.allFacts.filter((fact) => fact.selected).map((fact) => fact.id)
      const payload = fact.selected
        ? [...selectedFactsIds, fact.fact_id]
        : selectedFactsIds.filter((f) => f !== fact.fact_id)
      this.$emit('change:facts', payload)
    },
  },
}
</script>

<style lang="less" scoped>
.loading{
  pointer-events: none;
}
.top-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.fact-list {
  max-width: 100%;
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  grid-column-gap: 15px;
  grid-row-gap: 15px;
  min-height: 0; /* NEW */
  min-width: 0;
  .fact-square {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .add-fact-card {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
